import { DocType } from "./types";

export const REVERIFY_MAX_FILES = 15;

export const getReverifyMaxFiles = (docType: DocType) =>
  docType === DocType.BenefitsStatement ? 1 : REVERIFY_MAX_FILES;
